// Navigation state that opens the campaign page with the selected filters read-only,
// e.g. when a campaign is started from a household card
export const lockedFiltersState = { shouldLockFilters: true };

// Checks if the campaign page was opened with its filters locked, e.g. from a household card
export const hasLockedFilters = (state: unknown): boolean => (
  typeof state === 'object'
  && state !== null
  && 'shouldLockFilters' in state
  && state.shouldLockFilters === true
);
